import Chip from '@mui/material/Chip';
import { CIReferralStatus } from 'components/CriticalIncident/interfaces';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface StatusCellProps {
    status: CIReferralStatus;
}

const STATUS_COLORS = {
    new: 'var(--color_neutral_30)',
    pending: 'var(--color_orange_background)'
} as const;

export const StatusCell: React.FC<StatusCellProps> = ({ status }) => {
    const { t } = useTranslation('criticalIncident', { useSuspense: false });

    const statusChipProps = useMemo(() => {
        return {
            [CIReferralStatus.Open]: { label: t('new'), style: { backgroundColor: STATUS_COLORS.new } },
            [CIReferralStatus.Accepted]: { label: t('pending'), style: { backgroundColor: STATUS_COLORS.pending } }
        }[status ?? CIReferralStatus.Open];
    }, [status, t]);

    return <Chip key="status" {...statusChipProps} />;
};
